export const TRANSLATIONS = {
  it: {
    nav: { storia: "La Storia", gusti: "I Gusti", semifreddi: "Semifreddi", lievitati: "Lievitati", orari: "Orari", recensioni: "Recensioni", contatti: "Contatti" },
    chapter: "Capitolo",
    status: {
      open: "Aperto ora · Chiude alle {time}",
      closed_today: "Chiuso oggi",
      opens_at: "Apre oggi alle {time}",
      closed_now: "Chiuso ora",
      force: "Chiuso temporaneamente",
    },
    hero: {
      line1: "L\u2019arte del gelato,",
      line2a: "firmata ",
      line2em: "Imperiale",
      line2b: ".",
      para: "Gelato artigianale, torte semifreddo e lievitati d\u2019autore. A Brescia, dal 1991.",
      cta1: "Scopri i gusti",
      cta2: "Dove trovarci",
      scroll: "Scorri la storia",
      badgeFresh: "Gelato fresco, ogni mattina",
    },
    marquee: ["Pistacchio", "Mascarpone", "Croccantino Imperiale", "Nutella", "Lotus", "Fragola", "Torte Semifreddo Artigianali", "Panettone a Lenta Lievitazione", "Brioche Artigianali", "Gelato Fresco Ogni Giorno"],
    storia: {
      title: "La Nostra Storia",
      subtitle: "Una storia che continua dal 1991",
      quote: "Rinnovare senza snaturare.",
      motto: "Il motto della nuova gestione",
      stats: ["anni di storia", "anni tra i gelatieri", "di lievitazione"],
      timeline: [
        { year: "1991", title: "La fondazione", text: "Gelateria Imperiale nasce a Brescia dall\u2019iniziativa di Rudy e Raffaella. Fin dall\u2019inizio si distingue per un gelato dal carattere deciso, intenso e diverso dagli altri: un prodotto senza compromessi, capace di conquistare una comunità di estimatori fedelissimi e di diventare uno dei nomi più conosciuti della città." },
        { year: "14.02.2019", title: "Il passaggio di testimone", text: "Dopo ventotto anni, i fondatori scelgono di passare il testimone: alla guida della gelateria arriva Paolo Possi, affiancato dal padre Lucio, storico gelatiere. Con loro entra in Imperiale l\u2019esperienza di una famiglia che opera nel mondo del gelato da oltre cinquant\u2019anni. La scelta è chiara fin dal principio: rinnovare senza snaturare, custodendo le ricette storiche e quel gusto inconfondibile che generazioni di clienti hanno imparato ad amare." },
        { year: "13.12.2019", title: "Un ambiente completamente nuovo", text: "Al termine della prima stagione prende vita un importante progetto di rinnovamento. Dopo due mesi di lavori, la gelateria riapre con un ambiente più contemporaneo e accogliente, ma ancora elegante e fedele alla sua anima classica." },
        { year: "2025", title: "Continuità e custodia", text: "A garantire la continuità contribuiscono il gelatiere e il pasticcere della precedente gestione, rimasti al fianco della nuova proprietà durante il passaggio. Anche Raffaella accompagna Imperiale fino al 2025, custodendone i valori e aiutando Paolo e Lucio a preservarne l\u2019autenticità." },
        { year: "Oggi", title: "Molto più di una gelateria", text: "Accanto al gelato cresce la pasticceria artigianale: il pasticcere francese realizza semifreddi e torte partendo dalle materie prime, senza preparati industriali, trasformando ogni creazione in una piccola opera d\u2019arte. L\u2019ingresso di un giovane pasticcere specializzato nei lievitati arricchisce la proposta con panettoni e colombe artigianali, tra i prodotti più richiesti. D\u2019inverno Imperiale accoglie con caffetteria, cioccolate calde, tè, tisane, biscotti e brioche; d\u2019estate il dehors illuminato crea un\u2019atmosfera urbana e suggestiva, dove gustare il gelato sotto le stelle, spesso accompagnati dalla musica dal vivo." },
      ],
      closing: "Una storia iniziata nel 1991, custodita con rispetto e proiettata verso il futuro. Questa è la nuova Gelateria Imperiale.",
    },
    gusti: {
      title: "I Gusti Cavalli di Battaglia",
      subtitle: "I sei gusti che i clienti tornano a cercare ogni giorno",
      whyLabel: "Perché lo amano",
      items: {
        pistacchio: {
          origin: "Il classico intramontabile",
          description: "Pistacchio puro di Sicilia, protagonista di una ricetta esclusiva che utilizza fino a tre volte la quantità di pistacchio delle preparazioni più comuni. Un gusto intenso, autentico e naturalmente irresistibile.",
          why: "Perché sa davvero di pistacchio. Il suo sapore pieno conquista al primo assaggio, mentre la straordinaria cremosità avvolge il palato e permane a lungo.",
        },
        mascarpone: {
          origin: "Cremosità assoluta",
          description: "Il mascarpone della Centrale del Latte di Brescia trasformato in gelato. Vellutato, avvolgente e irresistibilmente cremoso, ricorda il cuore più goloso del tiramisù.",
          why: "Conquista chi cerca un gusto morbido e ricco, capace di avvolgere il palato con la sua cremosità.",
        },
        croccantino: {
          origin: "La nostra firma",
          description: "Una morbida base al caramello incontra golosi pezzi di croccante alla nocciola. Il gusto che porta il nostro nome e racconta la nostra idea di golosità.",
          why: "Per il contrasto irresistibile tra la cremosità del gelato e la croccantezza delle nocciole. Chi lo prova, lo riprende.",
        },
        nutella: {
          origin: "Come fa a non piacere?",
          description: "Un gelato cremoso e irresistibile, preparato con la crema spalmabile più iconica del mondo. Un gusto inconfondibile che non ha bisogno di presentazioni.",
          why: "Perché riporta alla mente i ricordi più golosi dell\u2019infanzia e regala un piccolo momento di felicità a ogni assaggio.",
        },
        lotus: {
          origin: "Il biscotto diventato gelato",
          description: "Tutto il gusto inconfondibile del biscotto Lotus, con le sue note caramellate e leggermente speziate, trasformato in un gelato cremoso arricchito da golosa variegatura e briciole croccanti.",
          why: "Perché ogni cucchiaio alterna cremosità e croccantezza, in un equilibrio goloso che invita subito all\u2019assaggio successivo.",
        },
        fragola: {
          origin: "Una nuvola di fragole",
          description: "Il gusto fresco e intenso della fragola incontra una ricetta speciale con albume, che regala al gelato una consistenza straordinariamente soffice, leggera e ariosa.",
          why: "Perché conserva tutto il sapore della fragola, ma sorprende con una cremosità delicata e quasi spumosa che si scioglie piacevolmente in bocca.",
        },
      },
    },
    semifreddi: {
      title: "L\u2019Arte della Pasticceria",
      subtitle: "Torte gelato, mousse e semifreddi — decorati a mano, anche per matrimoni e grandi eventi",
      paras: [
        "Le torte gelato, le mousse e i semifreddi di Imperiale nascono dall\u2019esperienza di Christian, pasticcere francese con una lunga carriera nell\u2019alta ristorazione e nella pasticceria stellata. Ogni creazione parte dalle materie prime, senza preparati pronti, e unisce la raffinatezza della tradizione francese all\u2019eleganza della pasticceria contemporanea.",
        "Accanto alle torte diventate vere icone di Imperiale, proponiamo creazioni stagionali sempre nuove e realizziamo torte completamente personalizzate, progettate direttamente insieme al nostro pasticcere.",
        "Dalle composizioni più raccolte alle torte monumentali per matrimoni e grandi eventi, ogni dettaglio viene decorato a mano, anche attraverso tecniche preziose come lo zucchero soffiato e tirato e la pittura con acquerelli edibili. Per i grandi ricevimenti offriamo inoltre il trasporto e la finitura della torta direttamente sul posto.",
      ],
      closing: "Perché Gelateria Imperiale non è soltanto buon gelato: è pasticceria artigianale capace di dare forma alle occasioni più importanti.",
      menu: {
        croccante: "Croccante alle nocciole con soffice crema al mascarpone",
        millefoglie: "Strati di millefoglie e semifreddo alla crema",
        cremino: "Cioccolato fondente, alla gianduja e al latte",
        charlotte: "Savoiardi, frutti di bosco e mascarpone",
        tiramisu: "Mascarpone, savoiardi e caffè",
        tortagelato: "Gelato alla Crema, Nocciola, Cioccolato, Fiordilatte",
        mattonella: "Un\u2019icona della Brescianità: gelato alla Crema, Nocciola, Cioccolato con uno strato di Spumone",
        spumone: "Stecca di Panna e Torroncino con Nocciole, da gustare con o senza biscotti",
        meringata: "Semifreddo alla meringa con gocce di cioccolato e spumiglie",
      },
      note: "Su ordinazione · 48h di preavviso · Telefono 030 361440",
    },
    lievitati: {
      title: "I Lievitati d\u2019Autore",
      subtitle: "Panettoni, colombe pasquali e brioche sfogliate a lenta lievitazione naturale",
      quote: "48 ore di lenta lievitazione. La fretta non è un ingrediente.",
      items: {
        panettone: {
          badge: "Produzione Natalizia",
          description: "Preparato secondo il metodo classico, con doppio impasto e 48 ore di lievitazione: uova da galline allevate a terra, burro francese, canditi d\u2019arancia Agrimontana, uvetta e profumata vaniglia di Tahiti. A completarlo, l\u2019immancabile glassatura croccante, come vuole la migliore tradizione bresciana.",
        },
        colomba: {
          badge: "Edizione Pasquale",
          description: "Soffice nuvola di burro e arancia, coperta di glassa alle mandorle. Il nostro appuntamento di primavera.",
        },
        brioche: {
          badge: "Fresco ogni giorno",
          description: "Dalle classiche brioche da colazione alle soffici brioche siciliane da farcire con il gelato, ogni prodotto viene preparato artigianalmente nel nostro laboratorio. Impasti curati e lavorazioni attente danno vita a brioche fragranti, profumate e dal sapore unico e inconfondibile.",
        },
      },
    },
    orari: {
      title: "Orari & Giorni di Apertura",
      subtitle: "Sempre freschi, sempre pronti ad accogliervi",
      today: "Oggi",
      closed: "Chiuso",
      loading: "Caricamento orari…",
      days: { lun: "Lunedì", mar: "Martedì", mer: "Mercoledì", gio: "Giovedì", ven: "Venerdì", sab: "Sabato", dom: "Domenica" },
    },
    recensioni: {
      title: "Dicono di Noi — Solo 5 Stelle",
      subtitle: "La voce autentica dei nostri clienti, dalle recensioni di Google",
      cta: "Leggi tutte le recensioni su Google",
      loading: "Caricamento recensioni…",
    },
    contatti: {
      title: "Dove Trovarci & Contatti",
      subtitle: "Vieni a trovarci o prenota la tua torta semifreddo",
      addressLabel: "Indirizzo",
      phoneLabel: "Telefono",
      emailLabel: "Email",
      call: "Chiama ora",
      directions: "Indicazioni",
    },
    footer: {
      tagline: "Gelateria artigianale · dal 1991",
      rights: "© 2026 Gelateria Imperiale — Tutti i diritti riservati",
      admin: "Area Riservata Gestore",
    },
    chat: {
      title: "Assistente Imperiale",
      subtitle: "Risponde l\u2019AI della gelateria",
      welcome: "Ciao! Chiedimi di gusti, orari, torte semifreddo e lievitati.",
      suggestions: ["Siete aperti adesso?", "Quali sono i vostri gusti?", "Come ordino una torta semifreddo?"],
      placeholder: "Scrivi un messaggio…",
      error: "Ops, qualcosa è andato storto. Riprova tra poco o chiamaci allo 030 361440.",
      openAria: "Apri la chat con l\u2019assistente",
      sendAria: "Invia messaggio",
    },
  },

  en: {
    nav: { storia: "Our Story", gusti: "Flavours", semifreddi: "Semifreddi", lievitati: "Leavened Cakes", orari: "Hours", recensioni: "Reviews", contatti: "Contact" },
    chapter: "Chapter",
    status: {
      open: "Open now · Closes at {time}",
      closed_today: "Closed today",
      opens_at: "Opens today at {time}",
      closed_now: "Closed now",
      force: "Temporarily closed",
    },
    hero: {
      line1: "The art of gelato,",
      line2a: "signed ",
      line2em: "Imperiale",
      line2b: ".",
      para: "Artisan gelato, semifreddo cakes and signature leavened cakes. In Brescia, since 1991.",
      cta1: "Discover our flavours",
      cta2: "Find us",
      scroll: "Scroll the story",
      badgeFresh: "Fresh gelato, every morning",
    },
    marquee: ["Pistacchio", "Mascarpone", "Croccantino Imperiale", "Nutella", "Lotus", "Fragola", "Artisan Semifreddo Cakes", "Slow-Leavened Panettone", "Artisan Brioche", "Fresh Gelato Every Day"],
    storia: {
      title: "Our Story",
      subtitle: "A story that continues since 1991",
      quote: "Renewing without losing our soul.",
      motto: "The motto of the new management",
      stats: ["years of history", "years in gelato making", "of leavening"],
      timeline: [
        { year: "1991", title: "The foundation", text: "Gelateria Imperiale was born in Brescia from the initiative of Rudy and Raffaella. From the very beginning it stood out for a gelato with a decisive, intense character, unlike any other: an uncompromising product that won over a community of devoted admirers and became one of the best-known names in the city." },
        { year: "14.02.2019", title: "The handover", text: "After twenty-eight years, the founders chose to pass the torch: on 14 February 2019 a new chapter began, with Paolo Possi at the helm of the gelateria, flanked by his father Lucio, a veteran gelato maker. With them, Imperiale gained the experience of a family that has worked in the world of gelato for over fifty years. The choice was clear from the start: renew without losing identity, safeguarding the historic recipes and that unmistakable taste that generations of customers have learned to love." },
        { year: "13.12.2019", title: "A completely new setting", text: "At the end of the first season, an important renovation project came to life. After two months of works, the gelateria reopened with a more contemporary and welcoming space, still elegant and faithful to its classic soul." },
        { year: "2025", title: "Continuity and care", text: "Continuity was guaranteed by the gelato maker and the pastry chef of the previous management, who stood by the new ownership throughout the transition. Raffaella, too, accompanied Imperiale until 2025, guarding its values and helping Paolo and Lucio preserve its authenticity." },
        { year: "Today", title: "Much more than a gelateria", text: "Alongside gelato, artisan patisserie has grown: our French pastry chef creates semifreddi and cakes starting from raw ingredients, with no industrial mixes, turning every creation into a small work of art. A young pastry chef specialising in leavened doughs has further enriched the range with artisan panettone and colomba, now among the most requested products. In winter Imperiale welcomes guests with a coffee shop, hot chocolate, tea, herbal infusions, biscuits and brioche; in summer the illuminated dehors creates an evocative urban atmosphere, where gelato can be enjoyed under the stars, often with live music." },
      ],
      closing: "A story that began in 1991, guarded with respect and looking to the future. This is the new Gelateria Imperiale.",
    },
    gusti: {
      title: "Our Signature Flavours",
      subtitle: "The six flavours our customers come back for every day",
      whyLabel: "Why they love it",
      items: {
        pistacchio: {
          origin: "The timeless classic",
          description: "Pure Sicilian pistachio, the star of an exclusive recipe that uses up to three times the amount of pistachio found in common preparations. An intense, authentic and naturally irresistible flavour.",
          why: "Because it truly tastes of pistachio. Its full flavour wins you over at first taste, while the extraordinary creaminess envelops the palate and lingers.",
        },
        mascarpone: {
          origin: "Absolute creaminess",
          description: "Mascarpone from the Centrale del Latte di Brescia turned into gelato. Velvety, enveloping and irresistibly creamy, it recalls the most indulgent heart of tiramisù.",
          why: "It wins over anyone looking for a soft, rich flavour, capable of wrapping the palate in its creaminess.",
        },
        croccantino: {
          origin: "Our signature",
          description: "A soft caramel base meets delicious pieces of hazelnut brittle. The flavour that bears our name and tells our idea of indulgence.",
          why: "For the irresistible contrast between the creaminess of the gelato and the crunch of the hazelnuts. Once you try it, you order it again.",
        },
        nutella: {
          origin: "How could anyone resist?",
          description: "A creamy, irresistible gelato made with the most iconic spread in the world. An unmistakable flavour that needs no introduction.",
          why: "Because it brings back the sweetest childhood memories and gives a little moment of happiness with every taste.",
        },
        lotus: {
          origin: "The biscuit turned gelato",
          description: "All the unmistakable taste of the Lotus biscuit, with its caramelised and lightly spiced notes, turned into a creamy gelato enriched with a delicious ripple and crunchy crumbs.",
          why: "Because every spoonful alternates creaminess and crunch, in an indulgent balance that immediately invites the next taste.",
        },
        fragola: {
          origin: "A cloud of strawberries",
          description: "The fresh, intense taste of strawberry meets a special recipe with egg white, giving the gelato an extraordinarily soft, light and airy texture.",
          why: "Because it keeps all the flavour of the strawberry, but surprises with a delicate, almost foamy creaminess that melts pleasantly in the mouth.",
        },
      },
    },
    semifreddi: {
      title: "The Art of Patisserie",
      subtitle: "Gelato cakes, mousses and semifreddi — hand-decorated, also for weddings and grand events",
      paras: [
        "Imperiale\u2019s gelato cakes, mousses and semifreddi are born from the experience of Christian, a French pastry chef with a long career in fine dining and Michelin-starred patisserie. Every creation starts from raw ingredients, with no ready-made mixes, and combines the refinement of French tradition with the elegance of contemporary patisserie.",
        "Alongside the cakes that have become true Imperiale icons, we offer ever-new seasonal creations and fully customised cakes, designed directly together with our pastry chef.",
        "From the most intimate compositions to monumental cakes for weddings and grand events, every detail is decorated by hand, even through precious techniques such as blown and pulled sugar and painting with edible watercolours. For large receptions we also offer transport and on-site finishing of the cake.",
      ],
      closing: "Because Gelateria Imperiale is not just great gelato: it is artisan patisserie capable of giving shape to life\u2019s most important occasions.",
      menu: {
        croccante: "Hazelnut brittle with soft mascarpone cream",
        millefoglie: "Layers of puff pastry and cream semifreddo",
        cremino: "Dark, gianduja and milk chocolate",
        charlotte: "Ladyfingers, wild berries and mascarpone",
        tiramisu: "Mascarpone, ladyfingers and coffee",
        tortagelato: "Cream, hazelnut, chocolate and fiordilatte gelato",
        mattonella: "A Brescian icon: cream, hazelnut and chocolate gelato with a layer of Spumone",
        spumone: "Cream and torroncino slice with hazelnuts, to enjoy with or without biscuits",
        meringata: "Meringue semifreddo with chocolate drops and little meringues",
      },
      note: "Made to order · 48h notice · Phone 030 361440",
    },
    lievitati: {
      title: "Signature Leavened Cakes",
      subtitle: "Panettone, Easter colomba and artisan brioche with slow natural leavening",
      quote: "48 hours of slow leavening. Haste is not an ingredient.",
      items: {
        panettone: {
          badge: "Christmas production",
          description: "Prepared according to the classic method, with double dough and 48 hours of leavening: eggs from free-range hens, French butter, Agrimontana candied orange, raisins and fragrant Tahitian vanilla. Finishing it all, the essential crunchy glaze, as the finest Brescian tradition demands.",
        },
        colomba: {
          badge: "Easter edition",
          description: "A soft cloud of butter and orange, covered with almond glaze. Our springtime appointment.",
        },
        brioche: {
          badge: "Fresh every day",
          description: "From classic breakfast brioche to the soft Sicilian brioche to fill with gelato, every product is prepared by hand in our workshop. Carefully crafted doughs and attentive workmanship create fragrant, aromatic brioche with a unique, unmistakable taste.",
        },
      },
    },
    orari: {
      title: "Opening Hours & Days",
      subtitle: "Always fresh, always ready to welcome you",
      today: "Today",
      closed: "Closed",
      loading: "Loading hours…",
      days: { lun: "Monday", mar: "Tuesday", mer: "Wednesday", gio: "Thursday", ven: "Friday", sab: "Saturday", dom: "Sunday" },
    },
    recensioni: {
      title: "What They Say — Only 5 Stars",
      subtitle: "The authentic voice of our customers, from Google reviews",
      cta: "Read all reviews on Google",
      loading: "Loading reviews…",
    },
    contatti: {
      title: "Where to Find Us & Contact",
      subtitle: "Come and visit us or book your semifreddo cake",
      addressLabel: "Address",
      phoneLabel: "Phone",
      emailLabel: "Email",
      call: "Call now",
      directions: "Directions",
    },
    footer: {
      tagline: "Artisan gelateria · since 1991",
      rights: "© 2026 Gelateria Imperiale — All rights reserved",
      admin: "Owner Area",
    },
    chat: {
      title: "Assistente Imperiale",
      subtitle: "The gelateria\u2019s AI answers",
      welcome: "Hi! Ask me about flavours, opening hours, semifreddo cakes and leavened specialties.",
      suggestions: ["Are you open now?", "What flavours do you have?", "How do I order a semifreddo cake?"],
      placeholder: "Type a message…",
      error: "Oops, something went wrong. Try again shortly or call us at 030 361440.",
      openAria: "Open the assistant chat",
      sendAria: "Send message",
    },
  },

  fr: {
    nav: { storia: "Notre Histoire", gusti: "Les Parfums", semifreddi: "Semifreddi", lievitati: "Grands Levains", orari: "Horaires", recensioni: "Avis", contatti: "Contact" },
    chapter: "Chapitre",
    status: {
      open: "Ouvert · Ferme à {time}",
      closed_today: "Fermé aujourd\u2019hui",
      opens_at: "Ouvre aujourd\u2019hui à {time}",
      closed_now: "Actuellement fermé",
      force: "Fermé temporairement",
    },
    hero: {
      line1: "L\u2019art de la glace,",
      line2a: "signé ",
      line2em: "Imperiale",
      line2b: ".",
      para: "Glace artisanale, tortes semifreddo et grands levains d\u2019auteur. À Brescia, depuis 1991.",
      cta1: "Découvrir les parfums",
      cta2: "Nous trouver",
      scroll: "Faites défiler l\u2019histoire",
      badgeFresh: "Glace fraîche, chaque matin",
    },
    marquee: ["Pistacchio", "Mascarpone", "Croccantino Imperiale", "Nutella", "Lotus", "Fragola", "Tortes Semifreddo Artisanales", "Panettone à Lente Levée", "Brioches Artisanales", "Glace Fraîche Chaque Jour"],
    storia: {
      title: "Notre Histoire",
      subtitle: "Une histoire qui continue depuis 1991",
      quote: "Rénover sans dénaturer.",
      motto: "La devise de la nouvelle direction",
      stats: ["ans d\u2019histoire", "ans de métier", "de levée"],
      timeline: [
        { year: "1991", title: "La fondation", text: "La Gelateria Imperiale naît à Brescia de l\u2019initiative de Rudy et Raffaella. Dès le début, elle se distingue par une glace au caractère affirmé, intense et différente des autres : un produit sans compromis, capable de conquérir une communauté d\u2019amateurs fidèles et de devenir l\u2019un des noms les plus connus de la ville." },
        { year: "14.02.2019", title: "Le passage de témoin", text: "Après vingt-huit ans, les fondateurs choisissent de passer le témoin : le 14 février 2019, un nouveau chapitre s\u2019ouvre avec Paolo Possi à la tête de la gelateria, épaulé par son père Lucio, glacier historique. Avec eux entre chez Imperiale l\u2019expérience d\u2019une famille qui œuvre dans le monde de la glace depuis plus de cinquante ans. Le choix est clair dès le départ : rénover sans dénaturer, en gardant les recettes historiques et ce goût incomparable que des générations de clients ont appris à aimer." },
        { year: "13.12.2019", title: "Un cadre entièrement nouveau", text: "Au terme de la première saison naît un important projet de rénovation. Après deux mois de travaux, la gelateria rouvre avec un cadre plus contemporain et accueillant, mais toujours élégant et fidèle à son âme classique." },
        { year: "2025", title: "Continuité et transmission", text: "La continuité est assurée par le glacier et le pâtissier de la précédente direction, restés aux côtés de la nouvelle propriété pendant le passage. Raffaella accompagne elle aussi Imperiale jusqu\u2019en 2025, gardienne de ses valeurs, aidant Paolo et Lucio à préserver son authenticité." },
        { year: "Aujourd\u2019hui", title: "Bien plus qu\u2019une gelateria", text: "Aux côtés de la glace grandit la pâtisserie artisanale : le pâtissier français réalise semifreddi et tortes à partir de matières premières, sans préparations industrielles, faisant de chaque création une petite œuvre d\u2019art. L\u2019arrivée d\u2019un jeune pâtissier spécialisé dans les levains enrichit l\u2019offre de panettoni et colombes artisanaux, vite devenus parmi les produits les plus demandés. L\u2019hiver, Imperiale accueille ses clients avec café, chocolats chauds, thés, tisanes, biscuits et brioches ; l\u2019été, la terrasse illuminée crée une atmosphère urbaine et suggestive, où savourer la glace sous les étoiles, souvent au son de la musique live." },
      ],
      closing: "Une histoire commencée en 1991, gardée avec respect et tournée vers l\u2019avenir. Voici la nouvelle Gelateria Imperiale.",
    },
    gusti: {
      title: "Nos Parfums Signature",
      subtitle: "Les six parfums que nos clients reviennent chercher chaque jour",
      whyLabel: "Pourquoi ils l\u2019adorent",
      items: {
        pistacchio: {
          origin: "Le classique intemporel",
          description: "Pistache pure de Sicile, protagoniste d\u2019une recette exclusive qui utilise jusqu\u2019à trois fois la quantité de pistache des préparations les plus courantes. Un goût intense, authentique et naturellement irrésistible.",
          why: "Parce qu\u2019il a vraiment le goût de la pistache. Sa saveur pleine séduit dès la première dégustation, tandis que son extraordinaire onctuosité enveloppe le palais et persiste longtemps.",
        },
        mascarpone: {
          origin: "Onctuosité absolue",
          description: "Le mascarpone de la Centrale del Latte di Brescia transformé en glace. Velouté, enveloppant et irrésistiblement crémeux, il rappelle le cœur le plus gourmand du tiramisu.",
          why: "Il séduit ceux qui cherchent un goût doux et riche, capable d\u2019envelopper le palais de son onctuosité.",
        },
        croccantino: {
          origin: "Notre signature",
          description: "Une base souple au caramel rencontre de gourmands éclats de croquant à la noisette. Le parfum qui porte notre nom et raconte notre idée de la gourmandise.",
          why: "Pour le contraste irrésistible entre l\u2019onctuosité de la glace et le croquant des noisettes. Qui l\u2019essaie, le reprend.",
        },
        nutella: {
          origin: "Comment ne pas l\u2019aimer ?",
          description: "Une glace crémeuse et irrésistible, préparée avec la pâte à tartiner la plus emblématique au monde. Un goût inimitable qui n\u2019a pas besoin de présentation.",
          why: "Parce qu\u2019il ravive les souvenirs d\u2019enfance les plus gourmands et offre un petit moment de bonheur à chaque dégustation.",
        },
        lotus: {
          origin: "Le biscuit devenu glace",
          description: "Tout le goût incomparable du biscuit Lotus, avec ses notes caramélisées et légèrement épicées, transformé en une glace crémeuse enrichie d\u2019un marbré gourmand et de miettes croquantes.",
          why: "Parce que chaque cuillerée alterne onctuosité et croquant, dans un équilibre gourmand qui invite aussitôt à la dégustation suivante.",
        },
        fragola: {
          origin: "Un nuage de fraises",
          description: "Le goût frais et intense de la fraise rencontre une recette spéciale au blanc d\u2019œuf, qui donne à la glace une texture extraordinairement souple, légère et aérienne.",
          why: "Parce qu\u2019elle conserve toute la saveur de la fraise, mais surprend par une onctuosité délicate, presque mousseuse, qui fond agréablement en bouche.",
        },
      },
    },
    semifreddi: {
      title: "L\u2019Art de la Pâtisserie",
      subtitle: "Tortes glacées, mousses et semifreddi — décorés à la main, aussi pour mariages et grands événements",
      paras: [
        "Les tortes glacées, les mousses et les semifreddi d\u2019Imperiale naissent de l\u2019expérience de Christian, pâtissier français doté d\u2019une longue carrière dans la haute restauration et la pâtisserie étoilée. Chaque création part des matières premières, sans préparations toutes prêtes, et unit le raffinement de la tradition française à l\u2019élégance de la pâtisserie contemporaine.",
        "Aux côtés des tortes devenues de véritables icônes d\u2019Imperiale, nous proposons des créations saisonnières toujours nouvelles et réalisons des tortes entièrement personnalisées, conçues directement avec notre pâtissier.",
        "Des compositions les plus intimistes aux tortes monumentales pour mariages et grands événements, chaque détail est décoré à la main, y compris à travers des techniques précieuses comme le sucre soufflé et tiré et la peinture aux aquarelles comestibles. Pour les grandes réceptions, nous offrons en outre le transport et la finition de la torte sur place.",
      ],
      closing: "Parce que la Gelateria Imperiale n\u2019est pas seulement une bonne glace : c\u2019est une pâtisserie artisanale capable de donner forme aux occasions les plus importantes.",
      menu: {
        croccante: "Croquant aux noisettes et douce crème au mascarpone",
        millefoglie: "Feuilles de millefeuille et semifreddo à la crème",
        cremino: "Chocolat noir, gianduja et au lait",
        charlotte: "Biscuits à la cuillère, fruits des bois et mascarpone",
        tiramisu: "Mascarpone, biscuits à la cuillère et café",
        tortagelato: "Glace à la crème, noisette, chocolat et fiordilatte",
        mattonella: "Une icône de Brescia : glace à la crème, noisette et chocolat avec une couche de Spumone",
        spumone: "Tranche de crème et torroncino aux noisettes, à savourer avec ou sans biscuits",
        meringata: "Semifreddo à la meringue avec gouttes de chocolat et meringuettes",
      },
      note: "Sur commande · préavis de 48 h · Tél. 030 361440",
    },
    lievitati: {
      title: "Nos Spécialités Levées",
      subtitle: "Panettone, colombe de Pâques et brioches artisanales à lente levée naturelle",
      quote: "48 heures de lente levée. La hâte n\u2019est pas un ingrédient.",
      items: {
        panettone: {
          badge: "Production de Noël",
          description: "Préparé selon la méthode classique, avec double pâton et 48 heures de levée : œufs de poules élevées au sol, beurre français, oranges confites Agrimontana, raisins secs et parfumée vanille de Tahiti. Pour le couronner, l\u2019incontournable glaçage croquant, comme le veut la meilleure tradition bresciane.",
        },
        colomba: {
          badge: "Édition de Pâques",
          description: "Un nuage moelleux de beurre et d\u2019orange, couvert d\u2019un glaçage aux amandes. Notre rendez-vous du printemps.",
        },
        brioche: {
          badge: "Frais chaque jour",
          description: "Des brioches classiques du petit-déjeuner aux moelleuses brioches siciliennes à garnir de glace, chaque produit est préparé artisanalement dans notre atelier. Des pâtes soignées et un travail minutieux donnent naissance à des brioches parfumées au goût unique et incomparable.",
        },
      },
    },
    orari: {
      title: "Horaires & Jours d\u2019Ouverture",
      subtitle: "Toujours frais, toujours prêts à vous accueillir",
      today: "Aujourd\u2019hui",
      closed: "Fermé",
      loading: "Chargement des horaires…",
      days: { lun: "Lundi", mar: "Mardi", mer: "Mercredi", gio: "Jeudi", ven: "Vendredi", sab: "Samedi", dom: "Dimanche" },
    },
    recensioni: {
      title: "Ils Parlent de Nous — 5 Étoiles",
      subtitle: "La voix authentique de nos clients, issue des avis Google",
      cta: "Lire tous les avis sur Google",
      loading: "Chargement des avis…",
    },
    contatti: {
      title: "Où Nous Trouver & Contact",
      subtitle: "Venez nous rendre visite ou réservez votre torte semifreddo",
      addressLabel: "Adresse",
      phoneLabel: "Téléphone",
      emailLabel: "E-mail",
      call: "Appelez-nous",
      directions: "Itinéraire",
    },
    footer: {
      tagline: "Gelateria artisanale · depuis 1991",
      rights: "© 2026 Gelateria Imperiale — Tous droits réservés",
      admin: "Espace Gérant",
    },
    chat: {
      title: "Assistente Imperiale",
      subtitle: "L\u2019IA de la gelateria répond",
      welcome: "Bonjour ! Demandez-moi parfums, horaires, tortes semifreddo et spécialités levées.",
      suggestions: ["Êtes-vous ouverts ?", "Quels parfums avez-vous ?", "Comment commander une torte semifreddo ?"],
      placeholder: "Écrivez un message…",
      error: "Oups, une erreur est survenue. Réessayez dans un instant ou appelez le 030 361440.",
      openAria: "Ouvrir le chat de l\u2019assistant",
      sendAria: "Envoyer le message",
    },
  },

  de: {
    nav: { storia: "Unsere Geschichte", gusti: "Sorten", semifreddi: "Semifreddi", lievitati: "Hefespezialitäten", orari: "Öffnungszeiten", recensioni: "Bewertungen", contatti: "Kontakt" },
    chapter: "Kapitel",
    status: {
      open: "Jetzt geöffnet · Schließt um {time}",
      closed_today: "Heute geschlossen",
      opens_at: "Öffnet heute um {time}",
      closed_now: "Jetzt geschlossen",
      force: "Vorübergehend geschlossen",
    },
    hero: {
      line1: "Die Kunst des Eises,",
      line2a: "signiert ",
      line2em: "Imperiale",
      line2b: ".",
      para: "Handwerkliches Eis, Semifreddo-Torten und Hefespezialitäten mit Handschrift. In Brescia, seit 1991.",
      cta1: "Sorten entdecken",
      cta2: "So finden Sie uns",
      scroll: "Die Geschichte entdecken",
      badgeFresh: "Frisches Eis, jeden Morgen",
    },
    marquee: ["Pistacchio", "Mascarpone", "Croccantino Imperiale", "Nutella", "Lotus", "Fragola", "Handgemachte Semifreddo-Torten", "Panettone mit langer Führung", "Handwerkliche Brioches", "Jeden Tag frisches Eis"],
    storia: {
      title: "Unsere Geschichte",
      subtitle: "Eine Geschichte, die seit 1991 weitergeht",
      quote: "Erneuern, ohne zu verfälschen.",
      motto: "Das Motto der neuen Führung",
      stats: ["Jahre Geschichte", "Jahre Erfahrung", "Gehzeit"],
      timeline: [
        { year: "1991", title: "Die Gründung", text: "Die Gelateria Imperiale entsteht in Brescia aus der Initiative von Rudy und Raffaella. Von Anfang an zeichnet sie sich durch ein Eis mit entschlossenem, intensivem Charakter aus, das sich von allen anderen abhebt: ein kompromissloses Produkt, das eine Gemeinschaft treuer Liebhaber gewann und zu einem der bekanntesten Namen der Stadt wurde." },
        { year: "14.02.2019", title: "Die Übergabe", text: "Nach achtundzwanzig Jahren entschließen sich die Gründer, den Staffelstab weiterzugeben: Am 14. Februar 2019 beginnt ein neues Kapitel — Paolo Possi übernimmt die Leitung der Gelateria, an seiner Seite sein Vater Lucio, ein erfahrener Eismacher. Mit ihnen kommt die Erfahrung einer Familie ins Haus, die seit über fünfzig Jahren in der Welt des Eises tätig ist. Die Entscheidung ist von Anfang an klar: erneuern, ohne zu verfälschen — mit den historischen Rezepten und jenem unverwechselbaren Geschmack, den Generationen von Gästen lieben gelernt haben." },
        { year: "13.12.2019", title: "Ein völlig neues Ambiente", text: "Am Ende der ersten Saison entsteht ein bedeutendes Renovierungsprojekt. Nach zwei Monaten Arbeiten eröffnet die Gelateria neu: zeitgemäßer und einladender, aber weiterhin elegant und ihrer klassischen Seele treu." },
        { year: "2025", title: "Kontinuität und Bewahrung", text: "Für Kontinuität sorgen der Eismacher und der Konditor der früheren Führung, die der neuen Eigentümerschaft beim Übergang zur Seite standen. Auch Raffaella begleitet Imperiale bis 2025, hütet seine Werte und hilft Paolo und Lucio, seine Authentizität zu bewahren." },
        { year: "Heute", title: "Weit mehr als eine Gelateria", text: "Neben dem Eis wächst die handwerkliche Konditorei: Unser französischer Pâtissier kreiert Semifreddi und Torten ausschließlich aus Rohzutaten, ohne industrielle Fertigmischungen, und macht jede Kreation zu einem kleinen Kunstwerk. Ein junger, auf Hefeteige spezialisierter Konditor bereichert das Angebot mit handwerklichem Panettone und Colomba, die rasch zu den gefragtesten Produkten wurden. Im Winter empfängt Imperiale seine Gäste mit Café, heißer Schokolade, Tee, Kräutertees, Keksen und Brioches; im Sommer schafft die beleuchtete Terrasse eine städtische, stimmungsvolle Atmosphäre, in der man das Eis unter den Sternen genießt, oft begleitet von Live-Musik." },
      ],
      closing: "Eine Geschichte, die 1991 begann, mit Respekt bewahrt und in die Zukunft gerichtet. Das ist die neue Gelateria Imperiale.",
    },
    gusti: {
      title: "Unsere Signatur-Sorten",
      subtitle: "Die sechs Sorten, zu denen unsere Gäste jeden Tag zurückkehren",
      whyLabel: "Warum alle sie lieben",
      items: {
        pistacchio: {
          origin: "Der zeitlose Klassiker",
          description: "Reine sizilianische Pistazie, Protagonistin eines exklusiven Rezepts, das bis zu dreimal so viel Pistazie verwendet wie übliche Zubereitungen. Ein intensiver, authentischer und von Natur aus unwiderstehlicher Geschmack.",
          why: "Weil sie wirklich nach Pistazie schmeckt. Ihr voller Geschmack überzeugt beim ersten Löffel, während die außergewöhnliche Cremigkeit den Gaumen umhüllt und lange nachwirkt.",
        },
        mascarpone: {
          origin: "Absolute Cremigkeit",
          description: "Mascarpone der Centrale del Latte di Brescia, verwandelt in Eis. Samtig, umhüllend und unwiderstehlich cremig — er erinnert an das verführerischste Herz des Tiramisù.",
          why: "Überzeugt alle, die eine sanfte, reichhaltige Sorte suchen, die den Gaumen mit ihrer Cremigkeit umhüllt.",
        },
        croccantino: {
          origin: "Unsere Handschrift",
          description: "Eine sanfte Karamellbasis trifft auf köstliche Stücke Haselnusskrokant. Die Sorte, die unseren Namen trägt und unsere Idee von Genuss erzählt.",
          why: "Für den unwiderstehlichen Kontrast zwischen der Cremigkeit des Eises und dem Knuspern der Haselnüsse. Wer sie probiert, nimmt sie wieder.",
        },
        nutella: {
          origin: "Wie könnte sie nicht gefallen?",
          description: "Ein cremiges, unwiderstehliches Eis, zubereitet mit der bekanntesten Nuss-Nougat-Creme der Welt. Ein unverwechselbarer Geschmack, der keiner Vorstellung bedarf.",
          why: "Weil sie die süßesten Kindheitserinnerungen weckt und mit jedem Löffel einen kleinen Glücksmoment schenkt.",
        },
        lotus: {
          origin: "Der Keks, der zum Eis wurde",
          description: "Der ganze unverwechselbare Geschmack des Lotus-Kekses mit seinen karamelligen, leicht würzigen Noten — verwandelt in ein cremiges Eis, verfeinert mit köstlicher Variegato und knusprigen Keksstückchen.",
          why: "Weil jeder Löffel Cremigkeit und Knusprigkeit abwechselt — eine köstliche Balance, die sofort zum nächsten Löffel einlädt.",
        },
        fragola: {
          origin: "Eine Wolke aus Erdbeeren",
          description: "Der frische, intensive Erdbeergeschmack trifft auf ein besonderes Rezept mit Eiweiß, das dem Eis eine außergewöhnlich weiche, leichte und luftige Konsistenz verleiht.",
          why: "Weil sie den vollen Erdbeergeschmack bewahrt, aber mit einer zarten, fast schaumigen Cremigkeit überrascht, die angenehm im Mund zergeht.",
        },
      },
    },
    semifreddi: {
      title: "Die Kunst der Pâtisserie",
      subtitle: "Eistorten, Mousses und Semifreddi — von Hand dekoriert, auch für Hochzeiten und große Feste",
      paras: [
        "Die Eistorten, Mousses und Semifreddi von Imperiale entstehen aus der Erfahrung von Christian, einem französischen Pâtissier mit langer Karriere in der gehobenen Gastronomie und der Sterne-Pâtisserie. Jede Kreation beginnt bei den Rohzutaten, ganz ohne Fertigmischungen, und verbindet die Raffinesse der französischen Tradition mit der Eleganz zeitgenössischer Pâtisserie.",
        "Neben den Torten, die zu wahren Imperiale-Ikonen geworden sind, bieten wir stets neue saisonale Kreationen und fertigen vollständig personalisierte Torten, die direkt mit unserem Pâtissier geplant werden.",
        "Von den intimsten Kompositionen bis zu monumentalen Torten für Hochzeiten und große Anlässe wird jedes Detail von Hand dekoriert — auch mit kostbaren Techniken wie geblasenem und gezogenem Zucker und der Malerei mit essbaren Aquarellfarben. Für große Empfänge bieten wir zudem den Transport und die Fertigstellung der Torte vor Ort an.",
      ],
      closing: "Denn die Gelateria Imperiale ist nicht nur gutes Eis: Sie ist handwerkliche Pâtisserie, die den wichtigsten Anlässen Form gibt.",
      menu: {
        croccante: "Haselnusskrokant mit weicher Mascarponecreme",
        millefoglie: "Schichten aus Blätterteig und Sahne-Semifreddo",
        cremino: "Zartbitter-, Gianduja- und Vollmilchschokolade",
        charlotte: "Löffelbiskuits, Waldbeeren und Mascarpone",
        tiramisu: "Mascarpone, Löffelbiskuits und Kaffee",
        tortagelato: "Eis mit Sahne, Haselnuss, Schokolade und Fiordilatte",
        mattonella: "Eine Brescia-Ikone: Sahne-, Haselnuss- und Schokoladeneis mit einer Schicht Spumone",
        spumone: "Sahne- und Torroncino-Stange mit Haselnüssen, mit oder ohne Kekse zu genießen",
        meringata: "Baiser-Semifreddo mit Schokoladentropfen und kleinen Baisers",
      },
      note: "Auf Bestellung · 48 h Vorlauf · Tel. 030 361440",
    },
    lievitati: {
      title: "Hefespezialitäten mit Handschrift",
      subtitle: "Panettone, Oster-Colomba und handwerkliche Brioches mit langsamer, natürlicher Gehzeit",
      quote: "48 Stunden langsame Führung. Eile ist keine Zutat.",
      items: {
        panettone: {
          badge: "Weihnachtsedition",
          description: "Nach klassischer Methode zubereitet, mit doppeltem Teig und 48 Stunden Gehzeit: Eier von Bodenhühnern, französische Butter, Agrimontana-Orangat, Rosinen und duftende Tahiti-Vanille. Den Abschluss bildet die unverzichtbare knusprige Glasur, wie es die beste Brescianer Tradition verlangt.",
        },
        colomba: {
          badge: "Osteredition",
          description: "Eine weiche Wolke aus Butter und Orange, bedeckt mit Mandelglasur. Unser frühlingshafter Klassiker.",
        },
        brioche: {
          badge: "Jeden Tag frisch",
          description: "Von der klassischen Frühstücks-Brioche bis zur weichen sizilianischen Brioche zum Füllen mit Eis: Jedes Produkt wird handwerklich in unserem Labor hergestellt. Gepflegte Teige und aufmerksame Verarbeitung ergeben duftende, aromatische Brioches mit einzigartigem, unverwechselbarem Geschmack.",
        },
      },
    },
    orari: {
      title: "Öffnungszeiten & Tage",
      subtitle: "Immer frisch, immer bereit, Sie zu empfangen",
      today: "Heute",
      closed: "Geschlossen",
      loading: "Öffnungszeiten werden geladen…",
      days: { lun: "Montag", mar: "Dienstag", mer: "Mittwoch", gio: "Donnerstag", ven: "Freitag", sab: "Samstag", dom: "Sonntag" },
    },
    recensioni: {
      title: "Man sagt über uns — Nur 5 Sterne",
      subtitle: "Die authentische Stimme unserer Gäste, aus den Google-Bewertungen",
      cta: "Alle Bewertungen auf Google lesen",
      loading: "Bewertungen werden geladen…",
    },
    contatti: {
      title: "Hier finden Sie uns",
      subtitle: "Besuchen Sie uns oder bestellen Sie Ihre Semifreddo-Torte",
      addressLabel: "Adresse",
      phoneLabel: "Telefon",
      emailLabel: "E-Mail",
      call: "Jetzt anrufen",
      directions: "Route planen",
    },
    footer: {
      tagline: "Handwerkliche Gelateria · seit 1991",
      rights: "© 2026 Gelateria Imperiale — Alle Rechte vorbehalten",
      admin: "Inhaberbereich",
    },
    chat: {
      title: "Assistente Imperiale",
      subtitle: "Die KI der Gelateria antwortet",
      welcome: "Hallo! Fragen Sie mich nach Sorten, Öffnungszeiten, Semifreddo-Torten und Hefespezialitäten.",
      suggestions: ["Haben Sie gerade geöffnet?", "Welche Sorten haben Sie?", "Wie bestelle ich eine Semifreddo-Torte?"],
      placeholder: "Nachricht schreiben…",
      error: "Ups, etwas ist schiefgelaufen. Versuchen Sie es gleich erneut oder rufen Sie uns an: 030 361440.",
      openAria: "Assistenten-Chat öffnen",
      sendAria: "Nachricht senden",
    },
  },
};
